import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useContext } from 'react';
import i18n from '../locales/i18n.js';

var navbarContext = createContext(null);
var NavbarProvider = function (_a) {
    var children = _a.children, authApiBaseUrl = _a.authApiBaseUrl, authUiBaseUrl = _a.authUiBaseUrl, customLanguages = _a.customLanguages;
    i18n.init({ languages: customLanguages });
    var navbar = useState({
        authApiBaseUrl: authApiBaseUrl,
        authUiBaseUrl: authUiBaseUrl
    })[0];
    return (jsx(navbarContext.Provider, __assign({ value: navbar }, { children: children }), void 0));
};
var useNavbarContext = function () {
    var context = useContext(navbarContext);
    if (!context) {
        throw new Error("useNavbarContext must be used within a NavbarProvider");
    }
    return context;
};

export { NavbarProvider as default, useNavbarContext };
